export enum RetailCrmTitle {
  /**   * "No title", the counterpart of {@link RetailCrmSalutation.NONE}.   *   * Needed on update and sync: an omitted `title` is dropped from the JSON body and Retail CRM   * treats an absent field as unchanged, so a cleared title would silently come back.   */
  NONE = '',
  PROF = 'Prof.',
  DR = 'Dr.',
  PROF_DR = 'Prof. Dr.',
}
